import { render, staticRenderFns } from "./sales-location.vue?vue&type=template&id=708f1eb1"
import script from "./sales-location.vue?vue&type=script&lang=js"
export * from "./sales-location.vue?vue&type=script&lang=js"
import style0 from "./sales-location.vue?vue&type=style&index=0&id=708f1eb1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports